var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33398 3.33329C2.96579 3.33329 2.66732 3.63177 2.66732 3.99996V13.3333C2.66732 13.7015 2.96579 14 3.33398 14H12.6673C13.0355 14 13.334 13.7015 13.334 13.3333V3.99996C13.334 3.63177 13.0355 3.33329 12.6673 3.33329H3.33398ZM1.33398 3.99996C1.33398 2.89539 2.22941 1.99996 3.33398 1.99996H12.6673C13.7719 1.99996 14.6673 2.89539 14.6673 3.99996V13.3333C14.6673 14.4379 13.7719 15.3333 12.6673 15.3333H3.33398C2.22941 15.3333 1.33398 14.4379 1.33398 13.3333V3.99996Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33398 6.66663C1.33398 6.29844 1.63246 5.99996 2.00065 5.99996H14.0007C14.3688 5.99996 14.6673 6.29844 14.6673 6.66663C14.6673 7.03482 14.3688 7.33329 14.0007 7.33329H2.00065C1.63246 7.33329 1.33398 7.03482 1.33398 6.66663Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6673 0.666626C11.0355 0.666626 11.334 0.965103 11.334 1.33329V3.99996C11.334 4.36815 11.0355 4.66663 10.6673 4.66663C10.2991 4.66663 10.0007 4.36815 10.0007 3.99996V1.33329C10.0007 0.965103 10.2991 0.666626 10.6673 0.666626Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33398 0.666626C5.70217 0.666626 6.00065 0.965103 6.00065 1.33329V3.99996C6.00065 4.36815 5.70217 4.66663 5.33398 4.66663C4.96579 4.66663 4.66732 4.36815 4.66732 3.99996V1.33329C4.66732 0.965103 4.96579 0.666626 5.33398 0.666626Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWhite);
export default __webpack_public_path__ + "static/media/CalendarWhite.da47680d8caf7c565f06c18645c629a0.svg";
export { ForwardRef as ReactComponent };